import axiosInstance from "../../../interceptor/intercetptor-inctence";

export const getDepartmentList = (formData) => {
    return axiosInstance.post(`api/master/department/list`, formData);
}

export const statusDepartment = (id) => {
    return axiosInstance.post(`api/master/department/change-status?departmentId=${id}`,{});
}

export const deleteDepartment = (id) => {
    return axiosInstance.post(`api/master/department/delete?departmentId=${id}`,{});
}

export const addDepartment = (formData) => {
    return axiosInstance.post(`api/master/department/add`,formData);
}

export const updateDepartment = (formData) => {
    return axiosInstance.post(`api/master/department/update`,formData);
}

export const getGlobalDepartmentList = (formData) => {
    return axiosInstance.post(`api/global-master/department_master`,formData);
}

export const addGlobalDepartment = (formData) => {
    return axiosInstance.post(`api/global-master/import_department_master`,formData);
}
